import React from "react"

/**
 * Card - MINIMAL VERSION - Built from scratch to fix FOUC
 * 
 * STEP 1: Absolute minimum - just a div with inline styles
 */

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'glass' | 'surface' | 'classic' | 'ghost'
  size?: '1' | '2' | '3' | '4' | '5'
  /** Czy karta jest interaktywna (clickable) - dodaje role="button" i odpowiednie ARIA */
  interactive?: boolean
  /** ARIA label dla interaktywnych kart */
  ariaLabel?: string
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, variant = 'glass', size = '4', interactive = false, ariaLabel, style, ...props }, ref) => {
    
    // STEP 1: Inline styles ONLY - no classes at all
    const cardStyle: React.CSSProperties = {
      // Glassmorphism - inline to prevent FOUC
      background: 'rgba(17, 17, 17, 0.4)',
      backdropFilter: 'blur(20px) saturate(180%)',
      WebkitBackdropFilter: 'blur(20px) saturate(180%)',
      border: '1px solid rgba(233, 61, 130, 0.2)',
      boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.4), inset 0 1px 0 0 rgba(255, 255, 255, 0.05)',
      
      // Layout - inline
      padding: '2rem',
      borderRadius: '12px',
      
      // Transition
      transition: 'all 0.2s ease-out',
      
      // Interactive style
      cursor: interactive ? 'pointer' : 'default',
      
      // Merge with custom styles
      ...style,
    }
    
    // Keyboard handler dla interaktywnych kart
    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (interactive && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault()
        if (props.onClick) {
          props.onClick(e as any)
        }
      }
    }

    return (
      <div
        ref={ref}
        style={cardStyle}
        role={interactive ? 'button' : undefined}
        tabIndex={interactive ? 0 : undefined}
        aria-label={interactive ? ariaLabel : undefined}
        onKeyDown={handleKeyDown}
        {...props}
      >
        {children}
      </div>
    )
  }
)

Card.displayName = "Card"

// Temporary placeholders for other components
export const CardHeader = ({ children, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div style={{ marginBottom: '1.5rem' }} {...props}>{children}</div>
)

export const CardTitle = ({ children, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h3 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.75rem' }} {...props}>{children}</h3>
)

export const CardDescription = ({ children, ...props }: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p style={{ fontSize: '0.875rem', opacity: 0.8, marginBottom: '0.5rem' }} {...props}>{children}</p>
)

export const CardContent = ({ children, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div style={{ padding: '1.5rem 0' }} {...props}>{children}</div>
)

export const CardFooter = ({ children, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div style={{ marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.1)' }} {...props}>{children}</div>
)

export { Card }
